module.exports = __webpack_public_path__ + "static/media/mssg_menu_pt_BR.01aa1aea.png";